<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <div class="main" v-else>
    <!-- Side Navbar -->
    <SideBar />
    <!-- Body-Content -->
    <div class="body-content">
      <!-- Top Navbar -->
      <TopBar />
      <!-- Body -->
      <div class="container-fluid body-container">
        <!-- Content exists -->
        <section class="video_play_page" v-if="video">
          <p class="mt-0 mb-3">
            <a :href="mentorshipLink" class="link">
              <i class="fa fa-arrow-left" /> Voltar para as mentorias</a
            >
          </p>

          <!-- Usuário não possui acesso. -->
          <div v-if="!video.available">
            <div
              class="alert alert-warning mb-3 text-center"
              v-if="video.course_id === 'form-av'"
            >
              <i class="fa fa-lock" />
              Conteúdo disponível apenas para membros da
              <strong>Formação em Assistência Virtual</strong>.
              <div class="admin-buttons-h mt-3">
                <a class="btn" :href="purchasePage"
                  ><i class="fa fa-unlock" /> Liberar meu acesso</a
                >
                <!-- <a class="btn bg-secondary" :href="virtapClubPage" target="_blank"
                ><i class="fa fa-plus" /> Conheça todas as vantagens</a
              > -->
              </div>
            </div>
            <div
              class="alert alert-warning mb-3 text-center"
              v-if="video.course_id === 'form-ap'"
            >
              <i class="fa fa-lock" />
              Conteúdo disponível apenas para membros da
              <strong>Formação AExpert</strong>.
              <div class="admin-buttons-h mt-3">
                <a class="btn" :href="purchasePage"
                  ><i class="fa fa-unlock" /> Liberar meu acesso</a
                >
                <!-- <a class="btn bg-secondary" :href="virtapClubPage" target="_blank"
                ><i class="fa fa-plus" /> Conheça todas as vantagens</a
              > -->
              </div>
            </div>
            <div
                class="alert alert-danger mb-3 under-review"
                v-if="video.latest_expired_date"
              >
                <i class="fa-solid fa-circle-exclamation"></i>

                <span>
                  Seu acesso a esta mentoria
                  venceu em
                  <strong>{{
                    formatTimestamp(video.latest_expired_date)
                  }}</strong
                  >.</span
                >
              </div>

          </div>

          <!-- Usuário possui acesso. -->
          <div v-else>
            <div
              class="alert alert-info mb-3 under-review"
              v-if="video.latest_paid_purchase"
            >
              <i class="fa-solid fa-calendar-check"></i>

              <span>
                Seu acesso a esta mentoria é válido até
                <strong>{{
                  formatTimestamp(video.latest_paid_purchase.end_timestamp)
                }}</strong
                >.</span
              >
            </div>

            <!-- Usuário possui acesso à mentoria gravada, mas ela ainda não foi liberada. -->
            <div
              class="alert alert-warning mb-3 text-center under-review"
              v-if="video.locked && video.type !== 3"
            >
              <i class="fa-solid fa-lock"></i>
              <span>
                Este conteúdo ficará disponível em
                <strong>{{ formatDuration(video.remainingSeconds) }}</strong
                >.</span
              >
            </div>

            <!-- Usuário possui acesso à mentoria ao vivo, mas ela ainda não foi liberada. -->
            <div
              class="alert alert-warning mb-3 text-center under-review"
              v-else-if="video.locked && video.type === 3"
            >
              <i class="fa-solid fa-clock"></i>
              <span>
                Começa em
                <strong>{{ formatDuration(video.remainingSeconds) }}</strong
                >.</span
              >
            </div>
          </div>

          <!-- Title -->
          <h1 class="video-title">{{ video.title }}</h1>

          <!-- Video container -->
          <div class="row">
            <!-- Usuário não possui acesso -->
            <div class="col-lg-12" v-if="!video.available">
              <div class="video-container">
                <div class="banner" style="position: relative">
                  <div class="promo">
                    <strong v-if="video.course_id === 'form-av' || video.course_id === 'form-ap'"
                      >Conteúdo disponível apenas para membros</strong
                    ><br />
                    <div class="admin-buttons-h mt-3">
                      <a class="btn" :href="purchasePage"
                        ><i class="fa fa-shopping-cart" /> Liberar meu acesso</a
                      >
                    </div>
                  </div>
                  <img :src="getMentorshipThumbnailURL(video)" />
                </div>
              </div>
            </div>
            <!-- Usuário possui acesso, mas ainda não foi liberado. -->
            <div class="col-lg-12" v-else-if="video.locked">
              <div class="video-container">
                <div class="banner" style="position: relative" v-if="video.type === 3">
                  <div class="promo">
                    Começa em {{ formatDuration(video.remainingSeconds) }}.
                  </div>
                  <img :src="getMentorshipThumbnailURL(video)" />
                </div>
                <div class="banner" v-else style="position: relative">
                  <div class="promo">
                    Disponível em {{ formatDuration(video.remainingSeconds) }}.
                  </div>
                  <img :src="getMentorshipThumbnailURL(video)" />
                </div>
              </div>
            </div>
            <!-- Usuário possui acesso e conteúdo está liberado -->
            <div class="col-lg-12" v-else>
              <!-- Virtap Recorded Mentorship -->
              <div class="video-container" v-if="video.type === 4">
                <video-js
                  id="player"
                  controls
                  controlsList="nodownload"
                  fluid="true"
                  class="video-js vjs-theme-city vjs-big-play-centered"
                >
                  <source
                    x-src="http://sample.vodobox.net/skate_phantom_flex_4k/skate_phantom_flex_4k.m3u8"
                    :src="getMentorshipURL(video)"
                    type="application/x-mpegURL"
                    data-setup='{ "playbackRates": [0.5, 1, 1.5, 2] }'
                  />
                </video-js>

                <div
                  style="text-align: right"
                  class="class-completion mt-3 mb-0"
                  @click="toggleClassCompletion(!video.completed, true)"
                >
                  <div style="background: #fff" v-if="!video.completed">
                    <i class="fa-regular fa-square"></i>
                    <span style="margin-left: 5px">Marcar como visto</span>
                  </div>

                  <div class="class-completion complete" v-else>
                    <i class="fa-solid fa-check-square"></i>
                    <span style="margin-left: 5px">Marcar como visto</span>
                  </div>
                </div>
              </div>
              <!-- Live mentorship -->
              <div class="video-container full" v-else-if="video.type === 3">
                <div class="video-container">
                  <div class="banner">
                    <a
                      class="btn btn-secondary"
                      target="_blank"
                      :href="this.video.config.meetup_link"
                      >Participar do encontro</a
                    >
                  </div>
                </div>
              </div>
            </div>

            <!-- Video details -->
            <div class="col-lg-12" v-if="video.type === 3">
              <div class="video-details mt-3">
                <div class="wrap-box2 short">
                  <p class="break-word break-line" style="font-size: 14.2px">
                    {{ video.description }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-12" v-else-if="video.type === 4">
              <div class="video-details mt-3">
                <div
                  class="d-flex mb-2"
                  v-if="!video.locked && video.available"
                  style="
                    font-size: 14.2px;
                    gap: 20px;
                    flex-wrap: wrap;
                    align-items: center;
                  "
                >
                  <span class="fw-bold">{{
                    formatPlural(video.views, "visualização", "visualizações")
                  }}</span>
                  <!-- <span class="fw-bold">{{
                    formatElapsedTime(video.registration_timestamp)
                  }}</span> -->
                  <div
                    class="d-flex btn btn-small liked"
                    style="align-items: center; cursor: pointer"
                    v-if="video.liked"
                    @click="unlikeVideo()"
                  >
                    <span
                      >{{ video.likes }}
                      <i
                        class="fa-solid fa-thumbs-up"
                        style="font-size: 20px; margin-top: -4.8px"
                      ></i
                    ></span>
                  </div>
                  <div
                    class="d-flex btn btn-small"
                    style="align-items: center; cursor: pointer"
                    v-else
                    @click="likeVideo()"
                  >
                    <span
                      >{{ video.likes }}
                      <i
                        class="fa-regular fa-thumbs-up"
                        style="font-size: 20px; margin-top: -4.8px"
                      ></i
                    ></span>
                  </div>
                </div>
                <div class="wrap-box2">
                  <p class="break-word break-line" style="font-size: 14.2px">
                    {{ video.description }}
                  </p>
                </div>
                <div class="mt-3 mb-2" v-if="video.config && video.config.links">
                  <h2>Links:</h2>
                  <ul class="mt-2">
                    <li v-for="link in video.config.links">
                      <a :href="link.src" class="link" target="_blank">{{
                        link.title
                      }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Comment box -->
            <div class="col-lg-12 mt-4" v-if="video.type !== 3">
              <h3 class="comments-title mb-0">
                Comentários ({{ video.active_comments }})
              </h3>
              <hr
                style="margin-bottom: 0px; border-color: var(--border-color); opacity: 1"
                v-if="comments.length > 0"
              />
              <div>
                <div class="alert alert-warning mt-2" v-if="comments.length === 0">
                  Nenhum comentário foi postado ainda.
                </div>
                <div class="comments" v-else>
                  <div
                    class="box"
                    v-for="comment in comments"
                    :key="comment.id"
                    :id="comment.id"
                  >
                    <img :src="getImageURL(comment.picture)" v-if="comment.picture" />
                    <img class="empty-image" v-else />
                    <div class="c_text_area" style="flex-grow: 1">
                      <p class="name">
                        {{ comment.name ? comment.name : "Virtap"
                        }}
                        <!-- <span>{{
                          formatElapsedTime(comment.registration_timestamp)
                        }}</span> -->
                      </p>
                      <div class="wrap-box short">
                        <p
                          class="break-word dsc"
                          v-html="formatMultilineText(comment.comment)"
                        ></p>
                        <label></label>
                      </div>
                      <p class="under-review" v-if="comment.status === 1">
                        Seu comentário está aguardando moderação e encontra-se invisível
                        no momento.
                      </p>
                      <p class="inactive" v-else-if="comment.status === 3">
                        Seu comentário foi desativado.
                      </p>
                      <div
                        class="mt-2"
                        v-if="!comment.replyShown && comment.children_count > 0"
                      >
                        <button
                          class="btn btn-small bg-secondary"
                          :class="{ disabled: comment.showingReply }"
                          @click="showReply(comment)"
                        >
                          {{ comment.showingReply ? "Carregando..." : "Ver resposta" }}
                        </button>
                        <div
                          class="text-danger mt-2"
                          v-if="!comment.showingReply && comment.replyError"
                          style="font-size: 14px; line-height: 1.6"
                        >
                          <em
                            >Ocorreu um erro ao carregar a resposta.<br />
                            Por favor, tente novamente. Se o problema persistir, atualize
                            a página.</em
                          >
                        </div>
                      </div>
                      <div v-if="comment.replyShown">
                        <hr style="width: 100%; color: #aaa" />
                        <div class="box reply">
                          <img src="/favicon.svg" v-if="comment.picture" />
                          <div class="c_text_area" style="flex-grow: 1">
                            <p class="name">
                              Virtap
                              <!-- <span>{{
                                formatElapsedTime(comment.reply.registration_timestamp)
                              }}</span> -->
                            </p>
                            <p
                              class="break-word dsc"
                              v-html="formatMultilineText(comment.reply.comment)"
                            ></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="page_number" v-if="hasMore">
                  <button
                    id="fetchMoreComments"
                    class="btn see_more btn-small"
                    :class="{ disabled: loadingMore }"
                    @click="fetchMore()"
                    v-if="hasMore"
                  >
                    {{ loadingMore ? "Carregando..." : "Mostrar mais" }}
                  </button>
                </div>
                <div
                  v-if="loadMoreError"
                  class="text-center text-danger mt-2"
                  style="font-size: 15px; line-height: 1.6"
                >
                  <em>
                    Ocorreu um erro a o carregar comentários.<br />
                    Por favor, tente novamente. Se o problema persistir, atualize a
                    página.
                  </em>
                </div>
                <div class="comments-section" v-if="video.available && !video.locked">
                  <h3 class="comments-title mt-4">Adicione um comentário</h3>
                  <form
                    id="comment-form"
                    class="comment-form item"
                    onsubmit="return false"
                  >
                    <textarea
                      class="form-control"
                      id="txtComment"
                      style="height: 100px; font-size: 14.2px"
                      :disabled="posting"
                      :class="{ disabled: posting }"
                    ></textarea>
                    <em style="display: none; font-size: 12px" class="mt-2 mb-2"></em>
                    <p
                      class="text-danger mt-1"
                      style="display: none; font-size: 14px"
                      data-error
                    ></p>
                    <button
                      type="submit"
                      class="btn btn-medium mt-2 mb-4"
                      @click="addComment()"
                      :disabled="posting"
                      :class="{ disabled: posting }"
                    >
                      {{ posting ? "Por favor, aguarde..." : "Enviar" }}
                    </button>
                  </form>
                </div>
              </div>
              <!-- <p
                v-else
                class="mt-0 text-muted"
                style="font-size: 12pt; font-style: italic"
              >
                Apenas assinantes podem ver e postar comentários.
              </p> -->
            </div>
          </div>
        </section>
        <!-- Content doesn't exist -->
        <div class="center-block" v-else>
          <div>
            <div class="alert alert-danger mb-0 text-center">
              Mentoria não disponível.
              <p class="text-center">
                <a :href="mentorshipLink" class="btn mt-2">
                  <i class="fa fa-arrow-left" /> Voltar para as mentorias</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../SideBar.vue";
import TopBar from "../TopBar.vue";
import AssistantManager from "../../../js/services/assistant.js";
import StringUtils from "../../../js/utils/string.js";
import Config from "../../../../resources/config.js";

const RESULT_COUNT = 10;

export default {
  components: { SideBar, TopBar },

  created() {
    this.$store.commit("setActiveSection", "VideoListPage");
    this.loadVideo();
  },

  data() {
    return {
      video: null,
      posting: false,
      comments: [],
      loadingMore: false,
      loadMoreError: false,
      hasMore: true,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
    activeUser() {
      return this.$store.state.activeUser;
    },
    mentorshipLink() {
      if (this.video) {
        return `/mentorias/${this.video.course_id}`;
      } else {
        return "/mentorias";
      }
    },
    utmParams() {
      return (
        "utm_source=plataforma&utm_medium=assistentes&utm_campaign=mentoria-" +
        this.video.course_id +
        "&utm_content=" +
        this.video.id
      );
    },
    next() {
      return `mentoria/${this.video.id}`;
    },
    purchasePage() {
      let orderRef;
      if (this.video.course_id === "form-av") {
        orderRef = "FORMACAO_AV";
      } else if (this.video.course_id === "form-ap") {
        orderRef = "FORMACAO_AEXPERT";
      }

      return (
        Config.purchasePage +
        `?p=${orderRef}&${this.utmParams}&next=${this.next}`
      );
    }
  },

  methods: {
    async loadVideo() {
      let $ctx = this;
      this.$store.commit("setLoading", true);
      try {
        let response = await AssistantManager.getVideo(
          this.$route.params.id,
          RESULT_COUNT
        );

        if (response.video && response.video.type !== 3 && response.video.type !== 4) {
          this.video = null;
        } else {
          response.comments.forEach((c) => {
            c.replyShown = false;
            c.showingReply = false;
            c.reply = null;
            c.replyError = false;
          });

          this.video = response.video;
          this.comments = response.comments;
          this.hasMore = this.comments.length >= RESULT_COUNT;
        }

        if(response.assistant.open_offer) {
          this.showOfferModal(response.assistant.open_offer);
        }

        this.$store.commit("setActiveUser", response.assistant);
        this.$store.commit("setLoading", false);

        if (this.video) {
          this.$store.commit("setActiveSection", "MentorshipPage");
        } else {
          this.$store.commit("setActiveSection", "MentorshipNotFoundPage");
        }
        this.applyTruncation();
        if (!this.video || !this.video.available) {
          return;
        }

        if (this.video.locked) {
          let $ctx = this;
          let interval = setInterval(() => {
            if ($ctx.video.remainingSeconds === 0) {
              clearInterval(interval);
              location.reload();
              return;
            }
            $ctx.video.remainingSeconds--;
          }, 1000);
          return;
        }
        this.$nextTick(() => {
          $ctx.adjustVideo();
        });
      } catch (error) {
        this.handleAPIError(error, this.$route.fullPath.replace(/^\/+/, ""));
      }
    },

    async adjustVideo() {
      let $ctx = this;
      if (this.video.type === 4) {
        let player = videojs("player", {
          playbackRates: [0.5, 1, 1.5, 2],
          html5: {
            hls: {
              withCredentials: true,
            },
          },
        });

        player.ready(function () {
          player.on("ended", async function () {
            $ctx.toggleVideoCompletion(true, false);
          });

          player.play();
        });
      }
    },

    async addComment() {
      let $ctx = this;
      let $item = $("#txtComment").closest(".item");

      this.posting = true;

      try {
        let commentDetails = {
          video_id: this.video.id,
          comment: $("#txtComment").val(),
        };

        $item.removeClass("error");
        $item.find("em").hide();
        $item.find("[data-error]").hide();

        if (
          StringUtils.isEmpty(commentDetails.comment) ||
          commentDetails.comment.length < 10
        ) {
          $item.addClass("error");
          $item
            .find("em")
            .text("Por favor, informe um cometário com pelo menos 10 caracteres.")
            .show();
          $("#txtComment").focus();
          return;
        }

        let response = await AssistantManager.addComment(commentDetails);
        this.comments.unshift(response.comment);
        $("#txtComment").val("");
      } catch (error) {
        console.log(error);
        if (error.status === 401) {
          $item.find("[data-error]").html($ctx.buildSessionLink()).show();
        } else {
          $item
            .find("[data-error]")
            .html(
              $ctx.formatMultilineText(
                "Ocorreu um erro postar o comentário.\nPor favor, tente novamente. Se o problema persistir, atualize a página."
              )
            )
            .show();
        }
      } finally {
        this.posting = false;
      }
    },

    async toggleClassCompletion(flag, showError) {
      let $ctx = this;
      try {
        $ctx.video.completed = flag;
        await AssistantManager.completeVideo($ctx.video.id, flag);
      } catch (err) {
        console.log("Failure marking class as completed.", $ctx.video, err);
      }
    },

    async showReply(comment) {
      let $ctx = this;
      if (!this.video.available) {
        let title = "";
        if (this.video.course_id === "form-av") {
          title =
            "Esta mentoria faz parte da <strong>Formação em Assistência Virtual</strong>.<br>Para participar dos encontros, receber orientação e comentar nas aulas, faça parte da Formação.";
        }
        this.showSubscribeModal("Conteúdo exclusivo para membros", title, function ($m) {
          $m.find("[data-subscribe-now]")
            .off()
            .on("click", function () {
              location.href = $ctx.purchasePage;
            });

          $m.find("[data-know-more]")
            .hide();
        });

        return;
      } else if (this.video.locked) {
        this.showError(
          "Esta resposta será liberada em " +
            this.formatDuration(this.video.remainingSeconds) +
            ". Tente novamente depois."
        );
        return;
      }
      comment.showingReply = true;
      comment.replyError = false;

      try {
        let response = await AssistantManager.getVideoCommentReply(
          this.video.id,
          comment.id
        );
        if (response.comments.length > 0) {
          comment.reply = response.comments[0];
          comment.replyShown = true;
        }
      } catch (err) {
        console.log(err);
        comment.replyError = true;
      } finally {
        comment.showingReply = false;
      }
    },

    async fetchMore() {
      let ctx = this;
      ctx.loadingMore = true;
      ctx.loadMoreError = false;

      let lastComment = null;
      if (this.comments && this.comments.length > 0) {
        lastComment = this.comments[this.comments.length - 1];
      }
      try {
        let response = await AssistantManager.getVideoComments(
          ctx.video.id,
          lastComment,
          RESULT_COUNT
        );

        this.comments = this.comments.concat(response.comments);
        if (response.comments.length < RESULT_COUNT) {
          this.hasMore = false;
        }

        ctx.$nextTick(() => {
          ctx.applyTruncation(() => {
            if (response.comments.length > 0) {
              let card = $(".comments")
                .find("#" + response.comments[0].id)
                .get(0);
              let scrollDiv = card.offsetTop - 10;
              window.scrollTo({ top: scrollDiv, behavior: "smooth" });
            }
          });
        });
      } catch (err) {
        console.log(err);
        ctx.loadMoreError = true;
      } finally {
        ctx.loadingMore = false;
      }
    },

    async toggleVideoCompletion(flag, showError) {
      let $ctx = this;
      try {
        $ctx.video.completed = flag;
        await AssistantManager.completeVideo($ctx.video.id, flag);
      } catch (err) {
        console.log("Failure marking video as completed.", $ctx.video, err);
      }
    },

    async likeVideo() {
      try {
        this.video.likes++;
        this.video.liked = true;
        await AssistantManager.likeVideo(this.video.id);
      } catch (err) {
        console.log(err);
      }
    },

    async unlikeVideo() {
      try {
        this.video.likes--;
        this.video.liked = false;
        await AssistantManager.unlikeVideo(this.video.id);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
